import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-supervisor-filter-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfSupervisorFilterIconProps extends SvgIconProps {
  fillColor?: any;
}

/**
 * Icon used to indicate filter icon
 * @param props -
 * @example
 * @returns
 */
export function CcfSupervisorFilterIcon(props: CcfSupervisorFilterIconProps) {
  return (
    <SvgIcon {...props} width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M11.7225 1.4L7.67764 6.51V11.34L6.28285 12.11V6.51L6.00389 6.16L2.23795 1.4H11.7225ZM13.3963 0H0.564205C0.354986 0 0.145767 0.14 0.0760279 0.35C-0.0634511 0.56 0.00628841 0.84 0.145767 0.98L4.88805 7V13.3C4.88805 13.51 5.09727 13.79 5.30649 13.93C5.37623 14 5.51571 14 5.58545 14C5.65519 14 5.72493 14 5.86441 13.93L8.65399 12.46C8.86321 12.39 9.14217 12.18 9.14217 11.9V7L13.8845 0.98C14.0239 0.77 14.0239 0.56 13.9542 0.35C13.8147 0.14 13.6055 0 13.3963 0V0Z"
        fill={props?.fillColor ? props?.fillColor : '#03D7A'}
      />
    </SvgIcon>
  );
}

export default CcfSupervisorFilterIcon;
